export const PREFERENCE_DEFAULT_VALUE = true;
export const PREFERENCE_DEFAULT_READ_ONLY = false;
export const WORKFLOW_PREFERENCE_DEFAULT = {
    enabled: PREFERENCE_DEFAULT_VALUE,
    readOnly: PREFERENCE_DEFAULT_READ_ONLY,
};
export const CHANNEL_PREFERENCE_DEFAULT = {
    enabled: PREFERENCE_DEFAULT_VALUE,
};
export const DEFAULT_WORKFLOW_PREFERENCES = {
    all: WORKFLOW_PREFERENCE_DEFAULT,
    channels: {
        in_app: CHANNEL_PREFERENCE_DEFAULT,
        sms: CHANNEL_PREFERENCE_DEFAULT,
        email: CHANNEL_PREFERENCE_DEFAULT,
        push: CHANNEL_PREFERENCE_DEFAULT,
        chat: CHANNEL_PREFERENCE_DEFAULT,
    },
};
export var WorkflowCriticalityEnum;
(function (WorkflowCriticalityEnum) {
    WorkflowCriticalityEnum["CRITICAL"] = "critical";
    WorkflowCriticalityEnum["NON_CRITICAL"] = "nonCritical";
    WorkflowCriticalityEnum["ALL"] = "all";
})(WorkflowCriticalityEnum || (WorkflowCriticalityEnum = {}));
//# sourceMappingURL=preferences.const.js.map